// src/hooks/useOrientation.js
import { useEffect, useState } from "react";

export default function useOrientation() {
  const getOrientation = () =>
    window.matchMedia("(orientation: portrait)").matches ? "portrait" : "landscape";

  const [orientation, setOrientation] = useState(getOrientation());

  useEffect(() => {
    const mql = window.matchMedia("(orientation: portrait)");

    const handleChange = (e) => {
      setOrientation(e.matches ? "portrait" : "landscape");
    };

    if (mql.addEventListener) {
      mql.addEventListener("change", handleChange);
    } else {
      mql.addListener(handleChange);
    }

    return () => {
      if (mql.removeEventListener) {
        mql.removeEventListener("change", handleChange);
      } else {
        mql.removeListener(handleChange);
      }
    };
  }, []);

  return orientation;
}
